// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"9f3ee7c5","232":"c59e68f7","237":"307623eb","526":"aee35978"}[chunkId] + ".chunk.js";
};